import { debug } from 'console';
import React, { forwardRef, useEffect, useState } from 'react';

export type InputCpfCnpjProps = {
  isMarkValue?: boolean;
  type: 'CPF' | 'CNPJ' | 'CPF_CNPJ';
  onChange: (value: string | null) => void;
} & Omit<React.HTMLProps<HTMLInputElement>, 'onChange'>;

const InputCpfCnpj = forwardRef<HTMLInputElement, InputCpfCnpjProps>(
  (
    {
      isMarkValue,
      type,
      onChange,
      value,
      ...props
    },
    ref
  ) => {

    const applyMaskCpf = (data: string) => {
      let cpfValue = data;
      if (type == 'CPF' && cpfValue.length >= 11) {
        cpfValue = cpfValue.substring(0, 11);
      }

      let cpf = "";
      let parts = Math.ceil(cpfValue.length / 3);
      for (let i = 0; i < parts; i++) {
        if (i === 3) {
          cpf += `-${cpfValue.substr(i * 3)}`;
          break;
        }
        cpf += `${i !== 0 ? "." : ""}${cpfValue.substr(i * 3, 3)}`;
      }

      return cpf;
    }

    const applyMaskCnpj = (data: string) => {
      let cnpj = `${data.substr(0, 2)}.${data.substr(2, 3)}.${data.substr(
        5,
        3
      )}/`;
      
      if (data.length > 12) {
        cnpj += `${data.substr(8, 4)}-${data.substr(12, 2)}`;
      } else {
        cnpj += data.substr(8);
      }
      return cnpj;
    }

    const applyMaskCpfCnpj = (value: string) => {
      let data = value.replace(/\D/g, "");

      if (type == 'CPF_CNPJ') {
        // Aplica CPF ou CNPJ
        if (data.length > 11) {
          return applyMaskCnpj(data);
        } else {
          return applyMaskCpf(data);
        }
      }

      // Aplica CPF
      if (type == 'CPF') {
        return applyMaskCpf(data);
      }

      // Aplica CNPJ
      if (type == 'CNPJ' && data.length > 11) {
        return applyMaskCnpj(data);
      }

      return value;
    };

    return (
      <input
        {...props}
        ref={ref}
        onChange={(event) => {
          onChange(applyMaskCpfCnpj(event.currentTarget.value));
        }}
        value={value ? applyMaskCpfCnpj(value.toString()) : ''}
      />
    );
  }
);

InputCpfCnpj.displayName = 'InputCpfCnpj';

export {
  InputCpfCnpj
};
